import { Component, DoCheck } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements DoCheck {
  public session: boolean = false;

  constructor() {
    this.getSession();
  }

  ngDoCheck(): void {
    this.getSession();
  }

  getSession() {
    if (localStorage.getItem("session")) {
      this.session = true;
    } else {
      this.session = false;
    }
  }

  onLogin(event) {
    this.getSession();
  }
}
